export default {
  container: {
    '&:not(:first-child)': {
      marginTop: '6.5rem'
    }
  },
  wrapper: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    '& > * + *': {
      marginLeft: '2.5rem'
    }
  }
};